export default __webpack_public_path__ + "static/media/pirate_hat.fd8cde5b.svg";